import dataReportApiList from "../service/basic/dataReportApiList";
import { api } from "@/service/api";
const myhost = echarthostname;

// 开发：http://dev.diablo.ruigushop.com
//   测试：http://test-diablo.ruigushop.com
//   生成：http://diablo.ruigushop.com

// 获取数据看板信息
export function queryDataboard(params = {}) {
  return new Promise((resolve, reject) => {
    api
      .get(`${myhost}${dataReportApiList.getDataboard}`, {
        params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 获取数据看板信息
export function queryDatareport(params = {}) {
  return new Promise((resolve, reject) => {
    api
      .get(`${myhost}${dataReportApiList.getDatareport}`, {
        params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// 获取待处理工单列表
export function queryPendingOrder(params = {}) {
  return new Promise((resolve, reject) => {
    api
      .get(`${myhost}${dataReportApiList.getPendingOrder}`, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}



// WEBPACK FOOTER //
// ./src/models/dataReportmodel.js